"use strict";

/*** Smooth Scroll ***/
$('a[href*="#"]') // Remove links that don't actually link to anything
.not('[href="#"]').not('[href="#0"]').click(function (event) {
  // On-page links
  if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
    // Figure out element to scroll to
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']'); // Does a scroll target exist?

    if (target.length) {
      // Only prevent default if animation is actually gonna happen
      event.preventDefault();
      $('html, body').animate({
        scrollTop: target.offset().top - 80
      }, 1000);
    }
  }
});
/*** Menu ***/

function showNav() {
  $('.js-menu').addClass('nav-open');
  $('body').addClass('nav-open');
  window.setTimeout(function () {
    $('body').addClass('no_scroll');
  }, 200); // Firefox hack. Hides scrollbar as soon as menu animation is done

  $('.nav--main a').attr('tabindex', ''); // links inside navigation should be TAB selectable
}

function hideNav() {
  $('.js-menu').removeClass('nav-open');
  $('body').removeClass('nav-open');
  window.setTimeout(function () {
    $('body').removeClass('no_scroll');
  }, 10); // allow animations to start before removing class (Firefox)

  $('.nav--main a').attr('tabindex', '-1'); // links inside hidden navigation should not be TAB selectable
}

function navToggle() {
  if ($('.js-menu').hasClass('nav-open')) {
    hideNav();
  } else {
    showNav();
  }
}

$(document).ready(function () {
  $('.js-menu-toggle').on('click', function (e) {
    e.preventDefault();
    navToggle();
  });
  /*** Sub Menu ***/
  // var timerCareSetting,
  //   timerLearn;
  // $('.care-setting-menu').addClass('closed');
  // if ($(window).width() >= 768) {
  //   $('.care-setting-menu')
  //     .hover(
  //       function () {
  //         $('.care-setting-menu .sub-menu')
  //           .css({ display: 'flex' })
  //           .animate({ opacity: 1 }, 'fast');
  //         clearTimeout(timerCareSetting);
  //       },
  //       function () {
  //         timerCareSetting = setTimeout(() => {
  //           $('.care-setting-menu .sub-menu')
  //             .fadeTo(300, 0, function () { $(this).hide() })
  //         }, 750);
  //       }
  //     )
  //     .on('click', function () {
  //       clearTimeout(timerCareSetting);
  //     });
  // }
  // if ($(window).width() <= 767) {
  //   $('.care-setting-menu')
  //     .on('click', function () {
  //       $(this).toggleClass('closed');
  //     });
  // }
  // $('.care-setting-menu .sub-menu').on('mouseover', function () {
  //   clearTimeout(timerCareSetting);
  // });

  var timerProduct, timerMarket, timerLearn, timerCustomers;
  $('.product-menu').addClass('closed');

  if ($(window).width() >= 768) {
    $('.product-menu').hover(function () {
      $('.product-menu .sub-menu').css({
        display: 'flex'
      }).animate({
        opacity: 1
      }, 'fast');
      clearTimeout(timerProduct);
    }, function () {
      timerProduct = setTimeout(function () {
        $('.product-menu .sub-menu').fadeTo(300, 0, function () {
          $(this).hide();
        });
      }, 750);
    }).on('click', function () {
      clearTimeout(timerProduct);
    });
  }

  if ($(window).width() <= 767) {
    $('.product-menu').on('click', function () {
      $(this).toggleClass('closed');
    });
  }

  $('.product-menu .sub-menu').on('mouseover', function () {
    clearTimeout(timerProduct);
  });
  $('.market-menu').addClass('closed');

  if ($(window).width() >= 768) {
    $('.market-menu').hover(function () {
      $('.market-menu .sub-menu').css({
        display: 'flex'
      }).animate({
        opacity: 1
      }, 'fast');
      clearTimeout(timerMarket);
    }, function () {
      timerMarket = setTimeout(function () {
        $('.market-menu .sub-menu').fadeTo(300, 0, function () {
          $(this).hide();
        });
      }, 750);
    }).on('click', function () {
      clearTimeout(timerMarket);
    });
  }

  if ($(window).width() <= 767) {
    $('.market-menu').on('click', function () {
      $(this).toggleClass('closed');
    });
  }

  $('.market-menu .sub-menu').on('mouseover', function () {
    clearTimeout(timerMarket);
  });
  $('.learn-menu').addClass('closed');

  if ($(window).width() >= 768) {
    $('.learn-menu').hover(function () {
      $('.learn-menu .sub-menu').css({
        display: 'flex'
      }).animate({
        opacity: 1
      }, 'fast');
      clearTimeout(timerLearn);
    }, function () {
      timerLearn = setTimeout(function () {
        $('.learn-menu .sub-menu').fadeTo(300, 0, function () {
          $(this).hide();
        });
      }, 750);
    }).on('click', function () {
      clearTimeout(timerLearn);
    });
  }

  if ($(window).width() <= 767) {
    $('.learn-menu').on('click', function () {
      $(this).toggleClass('closed');
    });
  }

  $('.learn-menu .sub-menu').on('mouseover', function () {
    clearTimeout(timerLearn);
  });
  $('.customers-menu').addClass('closed');

  if ($(window).width() >= 768) {
    $('.customers-menu').hover(function () {
      $('.customers-menu .sub-menu').css({
        display: 'flex'
      }).animate({
        opacity: 1
      }, 'fast');
      clearTimeout(timerCustomers);
    }, function () {
      timerCustomers = setTimeout(function () {
        $('.customers-menu .sub-menu').fadeTo(300, 0, function () {
          $(this).hide();
        });
      }, 750);
    }).on('click', function () {
      clearTimeout(timerCustomers);
    });
  }

  if ($(window).width() <= 767) {
    $('.customers-menu').on('click', function () {
      $(this).toggleClass('closed');
    });
  }

  $('.customers-menu .sub-menu').on('mouseover', function () {
    clearTimeout(timerCustomers);
  });
  /*** Solution - Mobile Menu ***/

  $('.dropdown--secondary').on('click', function () {
    $(this).toggleClass('collapsed');
  });

  window.onclick = function (e) {
    if (!e.target.matches('.dropdown--secondary')) {
      if ($('.dropdown--secondary').hasClass('collapsed')) {
        $('.dropdown--secondary').removeClass('collapsed');
      }
    }
  };
  /*** Headroom ***/


  $(window).scroll(function () {
    if ($(window).scrollTop() > 10) {
      $('.header--main').addClass('shadow');
      $('.header--secondary').addClass('shadow');
    } else {
      $('.header--main').removeClass('shadow');
      $('.header--secondary').removeClass('shadow');
    }
  });
  $(window).scroll(function () {
    if ($(window).scrollTop() > 500) {
      $('header').addClass('not-top--delayed');
      $('.cta-dropdown').addClass('not-top--delayed');
    } else {
      $('header').removeClass('not-top--delayed');
      $('.cta-dropdown').removeClass('not-top--delayed');
    }
  });
  /*** Flickity ***/

  if ($('.logo-carousel').length) {
    var logoCarousel = $('.logo-carousel').flickity({
      fade: true,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      autoPlay: 6000,
      pauseAutoPlayOnHover: false,
      draggable: false
    });
    logoCarousel.css({
      opacity: 1
    });
    $('.logo-carousel').on('pointerUp.flickity', function () {
      logoCarousel.flickity('playPlayer');
    });
  }

  ;

  if ($('.testimonial-slider').length) {
    $('.testimonial-slider').each(function (index) {
      var testimonialSlider = $(this).flickity({
        fade: true,
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false
      });
      var testimonialPrev = $(this).next().find('.testimonial-button--prev');
      var testimonialNext = $(this).next().find('.testimonial-button--next');
      testimonialPrev.on('click', function () {
        testimonialSlider.flickity('previous');
      });
      testimonialNext.on('click', function () {
        testimonialSlider.flickity('next');
      });
      testimonialSlider.css({
        opacity: 1
      });
    });
  }

  ;

  if ($('.text-image-slider').length) {
    $('.text-image-slider').each(function (index) {
      var sliderTextImage = $(this).flickity({
        fade: true,
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        imagesLoaded: true
      });
      var prevTextImage = $(this).find('.text-image-button--prev');
      var nextTextIMage = $(this).find('.text-image-button--next');
      prevTextImage.on('click', function () {
        sliderTextImage.flickity('previous');
      });
      nextTextIMage.on('click', function () {
        sliderTextImage.flickity('next');
      });
      sliderTextImage.css({
        opacity: 1
      });
    });
  }

  ;

  if ($('.module-video').length) {
    $('.module-video').each(function (index) {
      var $buttonVideo = $(this).find('.button-video');
      var $iconPlay = $(this).find('.icon--play');
      var $iconPause = $(this).find('.icon--pause');

      if ($(this).find("video").length) {
        var $video = $(this).find("video");
        $buttonVideo.on('click', function () {
          if ($video.get(0).paused) {
            $video.get(0).play();
            $iconPlay.fadeOut();
            $iconPause.fadeIn();
          } else {
            $video.get(0).pause();
            $iconPause.fadeOut();
            $iconPlay.fadeIn();
          }
        });
        $video.on('play', function () {
          $iconPlay.fadeOut();
          $iconPause.fadeIn();
        });
        $video.on('ended', function () {
          $video.get(0).load();
          $video.get(0).pause();
          $video.get(0).currentTime = 0;
          $iconPause.fadeOut();
          $iconPlay.fadeIn();
        });
      }
    });
  }
  /*** Fancybox ***/


  var arrows = {
    // Arrows
    arrowLeft: '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left something-left" title="{{PREV}}">' + '<div><svg width="48px" height="89px" viewBox="0 0 48 89" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="People-Bio" transform="translate(-59.000000, -478.000000)" stroke="#979797" stroke-width="4"><polyline id="Path-2" points="105.466813 479.359531 62.3263442 522.5 105.466813 565.640469"></polyline></g></g></svg></div>' + "</button>",
    arrowRight: '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' + '<div><svg width="48px" height="89px" viewBox="0 0 48 89" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="People-Bio" transform="translate(-1309.000000, -478.000000)" stroke="#979797" stroke-width="4"><polyline id="Path-2-Copy" transform="translate(1332.273512, 522.500000) rotate(-180.000000) translate(-1332.273512, -522.500000) " points="1353.84375 479.359531 1310.70328 522.5 1353.84375 565.640469"></polyline></g></g></svg></div>' + "</button>"
  };
  $.fancybox.defaults.loop = true;
  $('[data-fancybox="swift-founders"]').fancybox({
    btnTpl: arrows
  });
  $('[data-fancybox="swift-investors"]').fancybox({
    btnTpl: arrows
  });
  $('[data-fancybox="swift-people"]').fancybox({
    btnTpl: arrows
  });
  $('[data-fancybox="gallery"]').fancybox({
    btnTpl: arrows
  });
});
/*** Form ***/

window.addEventListener('message', function (event) {
  if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {
    var $input = $(".hs-input"); // move label on input focus

    $input.on("focus", function () {
      $(this).parent().parent().addClass("active");
    }).blur(); // move label if input is empty or not

    $input.focusout(function () {
      if (!$(this).val()) {
        $(this).parent().parent().removeClass("active");
      } else {
        $(this).parent().parent().addClass("active");
      }
    }).focusout(); // focusout event for prefilled forms
  }
});
/*** Text ***/

$("p:has(small)").addClass("footnote");
/*** IE Custom Object Fit ***/

var userAgent, ieReg, ie;
userAgent = window.navigator.userAgent;
ieReg = /msie|Trident.*rv[ :]*11\./gi;
ie = ieReg.test(userAgent);

if (ie) {
  $(".hero").each(function () {
    var $container = $(this),
        imgUrl = $container.find("img").prop("src");

    if (imgUrl) {
      $container.css("backgroundImage", 'url(' + imgUrl + ')').addClass("custom-object-fit");
    }
  });
  $(".full-image-container").each(function () {
    var $container = $(this),
        imgUrl = $container.find("img").prop("src");

    if (imgUrl) {
      $container.css("backgroundImage", 'url(' + imgUrl + ')').addClass("custom-object-fit");
    }
  });
}

if ($("#article-topic").length) {
  $("#article-topic").multiselect({
    texts: {
      placeholder: 'Filter Topics'
    }
  });
}

if ($("#resource-topic").length) {
  $("#resource-topic").multiselect({
    texts: {
      placeholder: 'Filter Topics'
    }
  });
}

if ($("#resource-type").length) {
  $("#resource-type").multiselect({
    texts: {
      placeholder: 'Filter Types'
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  function formatNumber(value, decimals) {
    var s = (+value).toLocaleString('en-US').split(".");
    return decimals ? s[0] + "." + ((s[1] || "") + "00000000").substr(0, decimals) : s[0];
  }

  if (document.querySelectorAll('.stats__number').length) {
    var statsNumber = gsap.utils.toArray('.stats__number');
    statsNumber.forEach(function (stat, i) {
      gsap.from(stat, {
        textContent: stat.dataset.start,
        duration: stat.dataset.duration,
        ease: "none",
        modifiers: {
          textContent: function textContent(value) {
            return formatNumber(value, 0);
          }
        }
      });
      gsap.to(stat, {
        opacity: 1,
        duration: 1
      });
    });
  }

  if (document.querySelectorAll('.module--fadein').length) {
    var width = $(window).width();

    if (width > 980) {
      var modules = gsap.utils.toArray('.module--fadein');
      modules.forEach(function (module, i) {
        var animation = gsap.to(module, {
          duration: 0.8,
          y: 0,
          opacity: 1,
          paused: true
        });
        ScrollTrigger.create({
          trigger: module,
          end: "top center",
          once: true,
          onEnter: function onEnter(self) {
            self.progress === 1 ? animation.progress(1) : animation.play();
          }
        });
      });
    }
  }

  if (document.querySelectorAll('.module-text-image').length) {
    var timelineTextImages = [];
    var moduleTextImages = gsap.utils.toArray(".module-text-image");
    moduleTextImages.forEach(function (moduleTextImage, index) {
      timelineTextImages.push(gsap.timeline({
        scrollTrigger: {
          trigger: moduleTextImage,
          start: "top center",
          once: true
        }
      }));
      var listItems = moduleTextImage.querySelectorAll('.card-list-item');
      listItems.forEach(function (listItem, i) {
        timelineTextImages[index].from(listItem, {
          opacity: 0,
          duration: 0.8,
          ease: "powe3.out",
          stagger: 0.2
        });
      });
    });
  }
}); // /*** Book a Demo Idle Modal ***/
// function modalOpen() {
//   $('.modal--book-a-demo').addClass('modal--offstage'),
//     setTimeout(function () {
//       $('.modal--book-a-demo').addClass('modal--visible');
//     }, 20);
// }
// function modalClose() {
//   $('.modal--book-a-demo').removeClass('modal--visible'),
//     setTimeout(function () {
//       $('.modal--book-a-demo').removeClass('modal--offstage');
//     }, 20);
// }
// $('.modal--book-a-demo .modal-close').click(function (e) {
//   e.preventDefault();
//   modalClose();
// });
// var idleTimer = null,
//   idleState = false,
//   idleWait = 4000;
// if ($('.modal--book-a-demo').length) {
//   $(document).ready(function () {
//     $('*').bind('mousemove keydown scroll', function () {
//       clearTimeout(idleTimer);
//       idleState = false;
//       idleTimer = setTimeout(function () {
//         // Idle Event
//         modalOpen();
//         idleState = true;
//       }, idleWait);
//     });
//   });
// }